import { Clock, Heart, ChefHat } from "lucide-react";

export default function RecipeCard({ recipe, onOpen, fav, onFav, index = 0 }) {
  const missing = recipe.ingredients_missing?.length || 0;
  const have = recipe.ingredients_have?.length || 0;
  const pct = have + missing ? Math.round((have / (have + missing)) * 100) : 100;
  return (
    <div data-testid="recipe-card-item" onClick={() => onOpen(recipe)}
      className="rise group relative cursor-pointer rounded-3xl border border-[#1C241E]/10 bg-white p-5 transition-[transform,box-shadow] hover:-translate-y-1 hover:shadow-xl hover:shadow-[#2E6F40]/10"
      style={{ animationDelay: `${index * 0.06}s` }}>
      <button data-testid="recipe-favorite-button" aria-label="Preferito"
        onClick={(e) => { e.stopPropagation(); onFav(recipe); }}
        className="absolute top-4 right-4 rounded-full p-2 transition-colors hover:bg-[#FDF0ED]">
        <Heart className={`h-5 w-5 ${fav ? "fill-[#D95338] text-[#D95338]" : "text-[#4F5D52]"}`} />
      </button>
      <div className="flex items-center gap-3 font-mono text-xs text-[#4F5D52]">
        <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{recipe.time_minutes} min</span>
        <span className="inline-flex items-center gap-1"><ChefHat className="h-3.5 w-3.5" />{recipe.difficulty}</span>
      </div>
      <h3 className="mt-3 pr-8 font-display text-xl font-bold leading-snug">{recipe.title}</h3>
      <p className="mt-2 text-sm text-[#4F5D52] line-clamp-2">{recipe.description}</p>
      <div className="mt-4 flex flex-wrap gap-1.5">
        {(recipe.diets || []).map((d) => (
          <span key={d} className="rounded-full bg-[#E8F3EA] px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-[#2E6F40]">{d.replace("_", " ")}</span>
        ))}
      </div>
      <div className="mt-5">
        <div className="h-1.5 rounded-full bg-[#FDF0ED] overflow-hidden">
          <div className="h-full rounded-full bg-[#2E6F40]" style={{ width: `${pct}%` }} />
        </div>
        <p className="mt-2 text-xs font-medium text-[#4F5D52]">
          {missing === 0 ? <span className="text-[#2E6F40]">Hai tutto!</span> : <><span className="text-[#D95338]">{missing} mancant{missing > 1 ? "i" : "e"}</span> · {pct}% disponibile</>}
        </p>
      </div>
    </div>
  );
}
